
import React, { useEffect, useRef } from 'react';
import '../../../assets/css/screens/customer/privacyPolicy/PrivacyPolicy.css'; // External CSS file import
import Topbar from '../../../components/customer/home/topbar/Topbar';
import MyNavbar from '../../../components/customer/home/Navbar/MyNavbar';
import Myfooter from '../../../components/customer/home/footer/Myfooter';
import {
  Database, Eye, Share2, Lock, Trash2, Bell, Globe
} from 'lucide-react';
import ScrollToTop from '../../general/scrolltotop/ScrollToTop';

const SECTIONS = [
  {
    icon: <Database size={20} />,
    title: 'Information We Collect',
    text: 'We collect personal information you provide during registration (name, email, phone number, address), usage data, device information, and location data when you use our services.',
  },
  {
    icon: <Eye size={20} />,
    title: 'How We Use Your Information',
    text: 'Your information is used to provide and improve our services, process bookings, communicate updates, ensure safety, and personalize your experience on the platform.',
  },
  {
    icon: <Share2 size={20} />,
    title: 'Information Sharing',
    text: 'We share limited information with service providers for booking fulfillment, payment processors for transactions, and as required by law. We never sell your personal data.',
  },
  {
    icon: <Lock size={20} />,
    title: 'Data Security',
    text: 'We implement industry-standard security measures including encryption, secure servers, and regular security audits to protect your personal information.',
  },
  {
    icon: <Trash2 size={20} />,
    title: 'Data Retention & Deletion',
    text: 'We retain your data as long as your account is active. You can request data deletion by contacting our support team. Some data may be retained for legal compliance.',
  },
  {
    icon: <Bell size={20} />,
    title: 'Communications',
    text: 'We may send you service-related notifications, promotional offers, and updates. You can manage your notification preferences in your account settings.',
  },
  {
    icon: <Globe size={20} />,
    title: 'Cookies & Tracking',
    text: 'We use cookies and similar technologies to enhance your browsing experience, analyze usage patterns, and deliver personalized content.',
  },
];

const PrivacyPolicy = () => {
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = [];
    itemRefs.current.forEach((el) => {
      if (!el) return;
      const obs = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('pp-item--visible');
            obs.disconnect();
          }
        },
        { threshold: 0.15 }
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach(o => o.disconnect());
  }, []);

  return (
    <>
    <ScrollToTop/>
    <Topbar/>
    <MyNavbar/>
    <div className="pp-page">
      <div className="pp-container">

        {/* Header */}
        <div className="pp-header">
          <h2 className="pp-main-title">Privacy Policy</h2>
          <p className="pp-updated">Last updated: March 2026</p>
          <p className="pp-intro">
            At WorkHub, your privacy is our priority. This policy explains how we collect,
            use, and protect your personal information when you use our platform and services.
          </p>
        </div>

        {/* Sections */}
        <div className="pp-list">
          {SECTIONS.map((sec, i) => (
            <div
              key={i}
              className="pp-item"
              ref={el => (itemRefs.current[i] = el)}
              style={{ transitionDelay: `${i * 0.07}s` }}
            >
              <div className="pp-item__left">
                <div className="pp-item__icon">{sec.icon}</div>
                {i < SECTIONS.length - 1 && <div className="pp-item__line" />}
              </div>

              <div className="pp-item__content">
                <h5 className="pp-item__title">{sec.title}</h5>
                <p className="pp-item__text">{sec.text}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
    <Myfooter/>
    </>
  );
};

export default PrivacyPolicy;